import { useMe } from 'src/services/user';

export const useFeatureFlag = (feature_flag: string) => {
  const { me, isLoadingMe, isInitialLoading } = useMe();
  const featureFlags = me?.product_feature_flags ?? [];

  const isFeatureEnabled = featureFlags.some(
    (flag: string) => flag === feature_flag
  );

  return { isFeatureEnabled, isLoadingMe, isInitialLoading };
};
